import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from '../../../util/reactIntl';
import { IconSpinner } from '../../../components';
import css from './ProgressOverlay.module.css';

const ProgressOverlay = props => {
    const { message } = props;

    return (
        <div className={css.root}>
            <div className={css.content}>
                <IconSpinner className={css.spinner} />
                <p className={css.message}>
                    {message || <FormattedMessage id="ProgressOverlay.defaultMessage" />}
                </p>
            </div>
        </div>
    );
};

ProgressOverlay.defaultProps = {
    message: null,
};

ProgressOverlay.propTypes = {
    message: PropTypes.node,
};

export default ProgressOverlay; 